import { call, put, takeEvery } from 'redux-saga/effects';
import { ProgramActionKeys, programsActionCreators, UpdateCashDiscount } from '..';
import { IApiExecuteRespone } from '../../apiInterfaces';
import { showFailedRequestDialog } from '../../sagaUtils';
import { uiActionCreators } from '../../ui';
import * as api from '../programsApi';
import { IProgramCashDiscount } from '../programsInterfaces';

function* updateCashDiscountSaga(action: UpdateCashDiscount) {
  yield put(uiActionCreators.showSpinnerDialog());
  const response: IApiExecuteRespone<IProgramCashDiscount> = yield call(api.updateCashDiscount, action.payload);

  if (response.requestFailed) {
    yield showFailedRequestDialog(response);
  } else if (response.value) {
    yield put(programsActionCreators.setCashDiscounts([response.value]));
  }

  yield put(uiActionCreators.hideSpinnerDialog());
}

export function* watchUpdateCashDiscount() {
  yield takeEvery(ProgramActionKeys.UPDATE_CASH_DISCOUNT, updateCashDiscountSaga);
}
